import Select from 'antd/es/select';
import { useEffect, useMemo } from 'react';

import { useGetCustomerBusinessUnits } from 'api';

import { useOrganisationId } from 'hooks/context';

import { InputError } from '@atoms/InputError/InputError';

type Props = {
  onChange: (value: string) => void;
  errorMessage?: string;
  value: string;
  'data-testid'?: string;
};

export const BusinessUnitSelector = ({
  onChange,
  errorMessage,
  value,
  'data-testid': dataTestId
}: Props) => {
  const organisationId = useOrganisationId<number>();

  const { data: { data: businessUnits = [] } = {} } =
    useGetCustomerBusinessUnits(organisationId);

  const businessOptions = useMemo(() => {
    return businessUnits.map((unit) => ({
      value: unit.uuid,
      label: unit.name
    }));
  }, [businessUnits]);

  useEffect(() => {
    if (businessUnits?.length === 1) onChange(businessUnits[0].uuid);
  }, [businessUnits, onChange]);

  return (
    <>
      <Select
        value={value}
        options={businessOptions}
        onChange={onChange}
        disabled={businessOptions.length < 2}
        data-testid={dataTestId}
        placeholder="Select business unit"
      />

      <InputError errorMessage={errorMessage} />
    </>
  );
};
